
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#748190","stroke-width":"1.429","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_583_33846)"}},[_c('path',{attrs:{"d":"M17.85 2.643H9.278c-.789 0-1.428.64-1.428 1.429v5.714c0 .789.64 1.428 1.428 1.428h8.572c.789 0 1.428-.64 1.428-1.428V4.072c0-.79-.64-1.429-1.428-1.429z"}}),_c('path',{attrs:{"d":"M15.712 14.786h-10a1.429 1.429 0 01-1.429-1.429V6.215"}}),_c('path',{attrs:{"d":"M12.854 18.357H2.14A1.429 1.429 0 01.71 16.93V9.072"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_583_33846"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h20v19.999H0z"}})])])])
          )
        }
      }
    